import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  MessageResponse,
  MessageResponseType,
} from 'containers/InteractiveArea/Message';
import { updateCabinetSuccess } from 'containers/Configurator/actions/furniture';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/InteractiveArea/types';
import {
  makeSelectFurniture,
  makeSelectSelectedIdCabinet,
} from 'containers/Configurator/selectors/furniture';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';
import { displayTutorialAction } from 'containers/TutorialTour/actions';
import useMedia from 'use-media';

interface StateProps {
  furniture: Furniture | null;
  selectedIdCabinet: string | null;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  furniture: makeSelectFurniture(),
  selectedIdCabinet: makeSelectSelectedIdCabinet(),
});

interface Props {
  response: MessageResponse;
}

const MessageResponseEntry = ({ response }: Props) => {
  const dispatch = useDispatch();
  const { selectedIdCabinet, furniture } = useSelector(stateSelector);
  const isMobile = useMedia({ maxWidth: 1023 });

  const applyAction = () => {
    if (response.cabinet && selectedIdCabinet !== null && furniture !== null) {
      furniture.replace(response.cabinet, selectedIdCabinet);
      dispatch(updateCabinetSuccess(furniture, selectedIdCabinet));
    } else if (response.type === MessageResponseType.Tutorial) {
      dispatch(displayTutorialAction(true));
    } else {
      throw new Error("The response action doesn't have any cabinet");
    }
  };

  if (
    (response.type === MessageResponseType.Tutorial && isMobile) ||
    selectedIdCabinet === null
  )
    return null;

  return (
    <button
      className="mx-2 lg:mx-0 my-2 py-1 px-2 border border-gray-800 rounded"
      onClick={applyAction}
    >
      {response.content}
    </button>
  );
};

export default MessageResponseEntry;
